export default "__VITE_ASSET__CHiYQigF__"